import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Common";

const BG = "https://images.unsplash.com/photo-1604869515882-4d10fa4b0492?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={user.role === "tecnico" ? "/tecnico" : "/"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden bg-[#0B0F14] lg:block">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="brand-stripe absolute left-0 top-0 h-1 w-full" />
        <div className="relative flex h-full flex-col justify-between p-14 text-white">
          <div className="micro-label !text-zinc-400">ERP Telecom · Multi-Azienda</div>
          <div className="max-w-lg fade-up">
            <h1 className="font-display text-5xl font-extrabold leading-[1.05] tracking-tight">Delivery e Assurance,<br />dalla commessa al rapportino.</h1>
            <p className="mt-6 text-base text-zinc-300">Ordini, pianificazione squadre, interventi sul campo e validazione della produzione in un unico flusso per tutto il gruppo.</p>
          </div>
          <div />
        </div>
      </div>
      <div className="flex items-center justify-center bg-white px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <Logo className="h-12" />
          <h2 className="mt-10 font-display text-3xl font-extrabold">Accedi</h2>
          <p className="mt-2 text-sm text-muted-foreground">Gli account sono creati dall'amministratore.</p>
          <div className="mt-8 space-y-5">
            <div>
              <Label htmlFor="email" className="micro-label">Email</Label>
              <Input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" data-testid="login-email-input" />
            </div>
            <div>
              <div className="flex items-center justify-between"><Label htmlFor="password" className="micro-label">Password</Label><Link to="/password-dimenticata" className="text-xs text-muted-foreground underline hover:text-foreground" data-testid="forgot-password-link">Password dimenticata?</Link></div>
              <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12" data-testid="login-password-input" />
            </div>
            {error && <div className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</div>}
            <Button type="submit" disabled={busy} className="h-12 w-full text-base" data-testid="login-submit-button">
              {busy ? "Accesso in corso…" : <>Entra <ArrowRight className="ml-2 h-4 w-4" /></>}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
